import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Member } from 'src/app/model/member.model';
import { RegisterService } from './register.service';
import Swal from 'sweetalert2';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ValidationService } from 'src/app/core/service/validation.service';
import { SelectedItemService } from 'src/app/core/service/selected-item.service';
import { AuthenticationService } from 'src/app/core/service/authentication.service';
import liff from '@line/liff';
import { SelectItem } from 'primeng/api';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
})
export class RegisterComponent {
  CompanyID: string;
  UserID: string;
  Liff_ID: string;
  User = new Member();
  IsMember = false; //判斷是否已是會員
  Step = 1;
  CityList: any[] | null = null;
  SectionList: any[] | null = null;

  GenderList: any[] | null = null;
  VarietyTypeList: SelectItem[] | null = null;
  origVarietyList: any[];
  VarietyList: SelectItem[] | null = null;
  add2Charge: boolean = false;
  from: string; //紀錄前往頁面

  GenderType: any[] = [
    { value: 0, label: '女' },
    { value: 1, label: '男' },
  ];
  isOptionLoading: boolean = false;
  IsErr: boolean = false;
  isLoading: boolean = false;
  selectedItemService: any;
  subscription: Subscription = new Subscription();
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private RegisterService: RegisterService,
    private ValidationService: ValidationService,
    private SelectedItemService: SelectedItemService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.isOptionLoading = true;
    // 取得querystring param
    var query = this.route.queryParams.subscribe((value) => {
      this.CompanyID = value['CompanyID'];
      this.UserID = value['UserID'];
      this.Liff_ID = value['Liff_ID'];
    });
    this.User.CompanyID = this.CompanyID;
    this.User.LineID = this.UserID;
    this.getSelectOptionData();
    
    this.subscription.add(query);
  }
  //#region 初始化

  getSelectOptionData() {
    this.isOptionLoading = true;
    const getOption = this.RegisterService.GetSelectOptionData(
      this.CompanyID
    ).subscribe((result) => this.GetSelectOptionDataSucceed(result));
    this.subscription.add(getOption);
  }

  GetSelectOptionDataSucceed(result: any): void {
    this.GenderList = this.GenderType;
    this.CityList = this.SelectedItemService.convertToSelectItem(
      result["Citys"],
      'CityNo',
      'CityName'
    );
    this.origVarietyList = result["Variety"];
    this.VarietyTypeList = this.SelectedItemService.convertToSelectItem(
      result["VarietyType"],
      'ChNo',
      'ChName'
    );
    this.VarietyList = this.SelectedItemService.convertToSelectItem(
      result["Variety"],
      'ChNo',
      'ChName'
    );
    this.isOptionLoading = false;
  }
  //#endregion

  getSelectItems() {
    var subject = new BehaviorSubject<boolean>(false);
    var getCity = this.RegisterService.GetCitySelect().subscribe((res: any) => {
      this.GenderList = this.GenderType;
      this.CityList = this.SelectedItemService.convertToSelectItem(
        res,
        'CityNo',
        'CityName'
      );

      this.isOptionLoading = false;
      subject.next(true);
      subject.complete();
    });
    this.subscription.add(getCity);
    return subject.asObservable();
  }

  /**下一步 */
  nextStep() {
    this.isLoading = true;
    switch (this.Step) {
      case 1: //檢查會員存在
        if (!!this.User.Name && !!this.User.Telephone) {
          this.CheckUser();
        } else {
          Swal.fire({
            icon: 'error',
            title: '輸入錯誤',
          });
          this.isLoading = false;
        }
        break;
      case 2: //會員註冊
        if(!!this.User.Variety)
          this.User.Variety = this.User.Variety.value;
        
        var createMember = this.RegisterService.CreateMember(
          this.User
        ).subscribe((res: any) => {
          if (!!res.User.MemberNo) {
            this.initializeLineLiff(res.User.MemberName);
            this.authenticationService.login(res);
            this.Step++;
            this.GoPage();
          } else {
            //註冊失敗
            Swal.fire({
              icon: 'error',
              title: '註冊失敗',
            });
          }
          this.isLoading = false;
        });
        this.subscription.add(createMember);
        break;
      default:
        break;
    }
  }
  /**初始化Liff */
  initializeLineLiff(MemberName?: string) {
    var that = this;
    //先初始化lif
    liff
      .init({
        liffId: this.Liff_ID,
        withLoginOnExternalBrowser: true,
        //reset: true,
      })
      .then(() => {
        if(!!MemberName) that.SendLiffMsg(this.UserID, MemberName);
      })
      .catch((err: any) => {
        console.error(err.code, err.message);
      });
  }
  /**花送註冊成功訊息 */
  SendLiffMsg(UserID: string, MemberName: string) {
    //花送信息
    var Msg = JSON.parse(`{
      "type" : "text",
      "text" : "會員綁定成功!"
      }`);
    liff
      .sendMessages([Msg])
      .then(function (res) {
        console.log(res);
      })
      .catch(function (error: any) {
        console.log(error);
        Swal.fire({
          icon: 'error',
          title: error,
        });
      });
  }
  /**檢查使用者是否存在
   * remark: 不存在回傳null，存在回傳token
   * 若資料庫有找到符合的(名&手機)，則直接綁定不重複建立
   */
  CheckUser() {
    var checkUser = this.RegisterService.CheckUser(this.User).subscribe(
      (res) => {
        if (!!res) {
          this.IsMember = true;
          this.Step = 3;
          //導頁前須初始化
          this.initializeLineLiff();
          this.authenticationService.login(res);
          this.GoPage();
        } else {
          this.IsMember = false;
          this.Step = 2;
        }
        this.isLoading = false;
      }
    );
    this.subscription.add(checkUser);
  }
  /**導頁 */
  GoPage() {
    setTimeout(() => {
      // 5 秒后跳转到首頁
      this.router.navigate(['/'], {
            queryParams: {
              CompanyID: this.CompanyID,
              UserID: this.UserID,
              Liff_ID: this.Liff_ID,
            },
      });
    }, 5000); // 10000 毫秒 = 10 秒
  }
  /**上一步 */
  prevStep() {
    this.Step--;
  }
  /**取得鄉市鎮 */
  selectCity() {
    var selectCity = this.RegisterService.GetSectionSelect(
      this.User.Add1
    ).subscribe((res: any) => {
      this.SectionList = this.SelectedItemService.convertToSelectItem(
        res,
        'ZipCode',
        'Township'
      );
      
      this.add2Charge = true;
    });
    this.subscription.add(selectCity);
  }
  /**檢查電話格式 */
  CheckPhone() {
    var res = this.ValidationService.CheckPhone(this.User.Telephone);

    this.IsErr = !res;
  }
  /**選擇寵物類型 */
  SelectVarietyType(){
    if(!!this.User.VarietyType)
    {
      var alist = this.origVarietyList.filter(s=>s.ChValue2 == this.User.VarietyType);
      this.VarietyList = this.SelectedItemService.convertToSelectItem(
        alist,
        'ChNo',
        'ChName'
      );
    }else{
      this.VarietyList = this.SelectedItemService.convertToSelectItem(
        this.origVarietyList,
        'ChNo',
        'ChName'
      );
    }
  }
  /**驗證表單內容 */
  EditRequired(){
    return !!this.User.Name && !!this.User.Telephone && !!this.User.PetName && !!this.User.PetName && !!this.User.Variety && !!this.User.VarietyType;
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
